import { Link, useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiHome } from 'react-icons/fi';
import BrandLogo from '../BrandLogo';
import { useSiteConfig } from '../../context/SiteConfigContext';

/**
 * Split auth shell: gradient brand (left), white form panel (right).
 * Home always routes to /. Back uses browser history when available.
 */
export default function AuthSplitLayout({ title, subtitle, children, footerRow, extras }) {
  const navigate = useNavigate();
  const { config } = useSiteConfig();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <main className="auth-split-page">
      <aside className="auth-split-brand" aria-hidden>
        <div className="auth-split-brand__wash" />
        <div className="auth-split-brand__waves" />
        <div className="auth-split-brand__dots" />

        <div className="auth-split-brand__content auth-split-brand__content--configured">
          <BrandLogo linkTo="/" theme="dark" className="auth-split-brand-mark" />
          <p className="auth-split-brand__tagline">
            {config.meta_description || 'Explore the chain with clarity.'}
          </p>
        </div>
      </aside>

      <div className="auth-split-main">
        <div className="auth-split-panel">
          <div className="auth-split-panel__center">
            <nav className="auth-split-toolbar" aria-label="Page">
              <button type="button" className="auth-split-softlink" onClick={handleBack}>
                <FiChevronLeft aria-hidden />
                <span>Back</span>
              </button>
              <Link to="/" className="auth-split-softlink auth-split-softlink--strong">
                <FiHome aria-hidden />
                <span>Home</span>
              </Link>
            </nav>

            <header className="auth-split-header">
              <h1 className="auth-split-title">{title}</h1>
              {subtitle ? <p className="auth-split-subtitle">{subtitle}</p> : null}
            </header>

            <div className="auth-split-body">
              {children}
              {footerRow ? <div className="auth-split-footer-slot">{footerRow}</div> : null}
            </div>

            {extras}

            <footer className="auth-split-legal">
              <Link to="/">Terms of Service</Link>
              <span className="auth-split-legal__sep">|</span>
              <Link to="/">Privacy Policy</Link>
            </footer>
          </div>
        </div>
      </div>
    </main>
  );
}
